var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadSmall = function SvgDownloadSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.5 10.996v16.182l4.144-4.144 1.414 1.415-6.558 6.557-6.558-6.557 1.415-1.415 4.143 4.144V10.996zM15.221 38.018H33.78v-2H15.221z",
    clipRule: "evenodd"
  })));
};
export { SvgDownloadSmall as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OSA0OCIgZmlsbD0ibm9uZSI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICAgIGQ9Ik0yNS41IDEwLjk5NnYxNi4xODJsNC4xNDQtNC4xNDQgMS40MTQgMS40MTUtNi41NTggNi41NTctNi41NTgtNi41NTcgMS40MTUtMS40MTUgNC4xNDMgNC4xNDRWMTAuOTk2aDJaTTE1LjIyMSAzOC4wMThIMzMuNzh2LTJIMTUuMjIxdjJaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";